export default "__VITE_ASSET__BHNZ3WaU__"